export default function initScheduleStep() {
  const firstStep = document.querySelector('.step-item.first');
  if (!firstStep) return;

  const nextBtn = firstStep.querySelector('.btn');
  if (!nextBtn) return;

  const formatToIsoDate = (dateLabel) => {
    const date = new Date(dateLabel);
    if (Number.isNaN(date.getTime())) return null;

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
  };

  const updateButtonHref = (isoDate) => {
    const currentHref = nextBtn.getAttribute('href') || window.location.pathname;
    const url = new URL(currentHref, window.location.origin);

    url.searchParams.set('date', isoDate);
    nextBtn.setAttribute('href', `${url.pathname}${url.search}${url.hash}`);
  };

  document.addEventListener('click', (event) => {
    const dateBtn = event.target.closest('.vc-date__btn');
    if (!dateBtn) return;

    const dateLabel = dateBtn.getAttribute('aria-label');
    const isoDate = formatToIsoDate(dateLabel);
    if (!isoDate) return;

    nextBtn.classList.remove('disabled');
    updateButtonHref(isoDate);
  });
}
